// extracted by mini-css-extract-plugin
export default {"container":"tile_container__rqe6O","image":"tile_image__2u2X0","text":"tile_text__KH+TY"};